import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  orderBy,
  FirestoreError,
} from 'firebase/firestore';
import { firestore } from '../../config/firebase';
import { Course } from '@e-learning/shared/src/store/types';

/**
 * Fetch all courses from Firestore
 */
export const fetchAllCourses = async (): Promise<Course[]> => {
  try {
    const coursesRef = collection(firestore, 'courses');
    const q = query(coursesRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const courses: Course[] = [];
    querySnapshot.forEach((docSnapshot) => {
      const data = docSnapshot.data();
      courses.push({
        id: docSnapshot.id,
        title: data.title || '',
        description: data.description || '',
        category: data.category || '',
        sections: data.sections || [],
        youtubeLinks: data.youtubeLinks || [],
        createdAt: data.createdAt || '',
        updatedAt: data.updatedAt || '',
      } as Course);
    });
    
    return courses;
  } catch (error) {
    const firestoreError = error as FirestoreError;
    throw new Error(`Failed to fetch courses: ${firestoreError.message}`);
  }
};

/**
 * Fetch a single course by ID from Firestore
 */
export const fetchCourseById = async (courseId: string): Promise<Course | null> => {
  try {
    const courseRef = doc(firestore, 'courses', courseId);
    const courseSnapshot = await getDoc(courseRef);
    
    if (!courseSnapshot.exists()) {
      return null;
    }
    
    const data = courseSnapshot.data();
    return {
      id: courseSnapshot.id,
      title: data.title || '',
      description: data.description || '',
      category: data.category || '',
      sections: data.sections || [],
      youtubeLinks: data.youtubeLinks || [],
      createdAt: data.createdAt || '',
      updatedAt: data.updatedAt || '',
    } as Course;
  } catch (error) {
    const firestoreError = error as FirestoreError;
    throw new Error(`Failed to fetch course: ${firestoreError.message}`);
  }
};

